<template>
  <div class="capability-card" :style="cardStyle">
    <img class="capability-card__bg" :src="image" alt="" />
    <div class="capability-card__overlay"></div>
    <div class="capability-card__content">
      <h3 class="capability-card__title">{{ title }}</h3>
      <p class="capability-card__subtitle">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CapabilityCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    bgColor: {
      type: String,
      default: "#FBF8F3",
    },
    borderColor: {
      type: String,
      default: "#DDD4C4",
    },
  },
  computed: {
    cardStyle() {
      return {
        border: `1px solid ${this.borderColor}`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.capability-card {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  box-sizing: border-box;
  flex: 1;
  aspect-ratio: 16 / 9;

  &__bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    position: absolute;
    inset: 0;
  }

  &__overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.6) 0%,
      rgba(0, 0, 0, 0) 50%
    );
  }

  &__content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 22px;
    background-color: rgb(224, 230, 235);
    margin: 10px;
    border-radius: 10px;
  }

  &__title {
    font-family: $font-family;
    font-size: 30px;
    font-weight: 700;
    color: #000;
    margin: 0 0 14px 0;
    text-align: left;
  }

  &__subtitle {
    font-family: $font-family;
    font-size: 14px;
    font-weight: normal;
    color: rgba(0, 0, 0, 0.85);
    line-height: 1.72;
    margin: 0;
    text-align: left;
  }

  @media (max-width: 767px) {
    &__title {
      font-size: 24px;
    }

    &__subtitle {
      font-size: 13px;
    }
  }
}
</style>
